import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Dog, Cat } from "lucide-react";
import { api } from "../lib/api";
import { Autocomplete } from "./search/Autocomplete";
import { MyLocationButton, locLabel, locInput } from "./search/MyLocationButton";

export const SpeciesToggle = ({ value, onChange }) => (
  <div className="inline-flex rounded-full bg-[#E6F4EF] p-1" role="radiogroup" aria-label="Dyreart">
    {[["dog", "Hund", Dog], ["cat", "Kat", Cat]].map(([code, label, Icon]) => (
      <button key={code} type="button" role="radio" aria-checked={value === code} onClick={() => onChange(code)} data-testid={`search-species-${code}-button`}
        className={`inline-flex items-center gap-2 px-4 h-9 rounded-full text-sm font-semibold transition-colors ${value === code ? "bg-[#087F72] text-white shadow-sm" : "text-[#153C3A] hover:bg-white"}`}>
        <Icon className="h-4 w-4" aria-hidden="true" />{label}
      </button>
    ))}
  </div>
);

export const PlacesDatalist = () => {
  const [places, setPlaces] = useState([]);
  useEffect(() => {
    api.get("/public/places").then((r) => setPlaces(r.data)).catch(() => {});
  }, []);
  return <datalist id="vp-places">{places.map((p) => <option key={p.postal_code} value={p.postal_code}>{p.city}</option>)}</datalist>;
};

export const SearchForm = ({ initial = {} }) => {
  const nav = useNavigate();
  const [species, setSpecies] = useState(initial.species || "dog");
  const [service, setService] = useState(initial.service || "");
  const [location, setLocation] = useState(initial.location || "");
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/public/services", { params: { species } }).then((r) => setServices(r.data)).catch(() => {});
  }, [species]);

  const go = (loc, extra = {}) => {
    const p = new URLSearchParams({ species, service: service || "konsultation", radius: "25", ...extra });
    if (loc.trim()) { p.set("location", loc.trim()); p.set("sort", "distance"); }
    nav(`/sammenlign?${p.toString()}`);
  };
  const submit = (e) => { e.preventDefault(); go(location); };

  return (
    <form onSubmit={submit} className="card-vp p-5 sm:p-6 shadow-lg shadow-[#087F72]/5" data-testid="search-form" role="search">
      <SpeciesToggle value={species} onChange={setSpecies} />
      <div className="grid gap-3 mt-5 md:grid-cols-[1.3fr_1fr_auto]">
        <div>
          <label htmlFor="search-treatment" className="block text-xs font-semibold text-[#52706D] mb-1.5">Behandling</label>
          <select id="search-treatment" className="field-vp h-12" value={service} onChange={(e) => setService(e.target.value)} data-testid="search-treatment-select">
            <option value="">Vælg behandling…</option>
            {services.map((s) => <option key={s.id} value={s.slug}>{s.name_da}</option>)}
          </select>
        </div>
        <div>
          <Autocomplete id="search-location" label="Postnummer eller by" value={locLabel(location)} onChange={(v) => setLocation((p) => locInput(p, v))} groups={["places"]} placeholder="F.eks. 8000 eller Odense"
            onSelect={(g, v) => setLocation(v)} testid="search-postal-code-input" />
          <MyLocationButton className="mt-2" testid="search-my-location-button" onLocate={(c) => { setLocation(c); go(c, { sort: "distance" }); }} />
        </div>
        <div className="flex items-end">
          <button type="submit" className="btn-primary h-12 w-full md:w-auto px-7" data-testid="search-submit-button"><Search className="h-4 w-4" />Søg priser</button>
        </div>
      </div>
    </form>
  );
};
